import useTemplateInstance from "../../../hooks/useTemplateInstance";
import React, { useMemo, useRef } from "react";
import useComponentSize from "@rehooks/component-size";
import makeStyles from "@mui/styles/makeStyles";
import { getBoxSize } from "../../../../../utils";
import DrawTemplate from "../../../../../components/Template/DrawTemplate";
import { getFirstRenderPartByResource } from "../../../../../Providers/TemplateInstanceProvider";
import { Trans } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  templateContainer: {
    position: "absolute",
    "& .template-inner-container": {
      transition: "transform 0.3s",
      transitionTimingFunction: "ease-in",
    },
    "&.separate-from-background .template-inner-container": {
      boxShadow: "0px 3px 6px #00000029",
    },
  },
  templateOuterContainer: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    display: "flex",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    // Disable pull to refresh
    touchAction: "none",
    backgroundColor: (props) =>
      props.partOfPackage ? theme.palette.secondary.light : "initial",
  },
  pictureIdContainer: {
    position: "absolute",
    right: "5px",
    bottom: "5px",
    color: "#6f6f6f",
    fontSize: "14px",
    textShadow:
      "0.04em 0.04em 0 rgba(255, 255, 255, 0.55)," +
      "   -0.04em -0.04em 0 rgba(0, 0, 0, 0.45)," +
      "    0 0 0.25em rgba(0, 0, 0, 0.15)",
  },
}));

const TemplateContainer = ({ children, ...props }) => {
  const [state] = useTemplateInstance();
  const classes = useStyles({ ...props, partOfPackage: state.partOfPackage });

  const ref = useRef();
  const size = useComponentSize(ref);

  const [cSize, style, outerPos] = useMemo(() => {
    let horizontalPadding = 30;
    let verticalPadding = 10;

    // Hack ref Eyvind: If the width of the renderpart is a small portion of the template,
    // make more padding so we see more of the context
    if (props.zoomResource && props.zoomResource.type == "STRING") {
      const renderPart = getFirstRenderPartByResource(
        props.zoomResource,
        state.template,
      );
      const templateWidth = state.template.dimensions.width;

      // FIXME: Width should be relative to DPI
      if (
        renderPart.size.width < 100 ||
        renderPart.size.width / templateWidth <= 0.1
      ) {
        horizontalPadding = 60;
        verticalPadding = 30;
      }
    }

    let visibleArea = state.template.dimensions;

    if (state.template.trimBox) {
      visibleArea = state.template.trimBox;
    }

    const cSize = getBoxSize("fit-in", visibleArea, {
      width: size.width - horizontalPadding * 2,
      height: size.height - verticalPadding * 2,
    });
    const outerPos = {
      x: cSize.x,
      y: cSize.y,
      width: size.width - horizontalPadding * 2,
      height: size.height - verticalPadding * 2,
    };

    const style = {
      width: cSize.width + "px",
      height: cSize.height + "px",
      left: cSize.x + horizontalPadding + "px",
      top: cSize.y + verticalPadding + "px",
    };
    return [cSize, style, outerPos];
  }, [size, state]);

  console.log("Zoom resource", props.zoomResource);

  return (
    <div className={classes.templateOuterContainer} ref={ref}>
      <div
        className={`${classes.templateContainer} ${
          props.zoomResource ? "zoomed" : ""
        } ${
          state.template.separateFromBackground
            ? "separate-from-background"
            : ""
        }`}
        style={style}
      >
        <DrawTemplate
          templateInstance={state}
          containerSize={cSize}
          outerPosition={outerPos}
          {...props}
        />
      </div>
      {children}
      {props.zoomResource?.image?.webshopId && (
        <div className={classes.pictureIdContainer}>
          <Trans>Picture id:</Trans> {props.zoomResource?.image?.webshopId}
        </div>
      )}
    </div>
  );
};
export default TemplateContainer;
